import React from 'react';
import { theme } from '@robinpowered/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDoorOpen } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import {
  ResultIconTile,
  ResultName,
  ResultSubtext,
  ResultText,
} from '../styles';
import { InteractiveResultRow } from './InteractiveResultRow';
import type { SpaceSearchHit } from '../types';

interface SpaceResultProps {
  result: SpaceSearchHit;
  resultRef?: React.Ref<HTMLDivElement>;
  onSelect?: (result: SpaceSearchHit) => void;
}

export const SpaceResult: React.FC<SpaceResultProps> = ({
  result,
  resultRef,
  onSelect,
}) => {
  const { token } = theme.useToken();
  const location = [result.levelName, result.locationName]
    .filter(Boolean)
    .join(', ');
  const handleSelect = onSelect ? () => onSelect(result) : undefined;

  return (
    <InteractiveResultRow resultRef={resultRef} onSelect={handleSelect}>
      <ResultIconTile
        aria-hidden="true"
        style={{ background: token.colorFillQuaternary }}
      >
        <FontAwesomeIcon icon={faDoorOpen} />
      </ResultIconTile>
      <ResultText>
        <ResultName>{result.displayName}</ResultName>
        {location && <ResultSubtext>{location}</ResultSubtext>}
      </ResultText>
    </InteractiveResultRow>
  );
};
